import React, { useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Header from '../Header_Footer/Header'
import { SideNavs } from './routesNavs'
import { Collapse, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import ather from '../../../assets/images/Layer.png';
import LoadingBar from 'react-redux-loading-bar';




const drawerWidth = 200;

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: "100%",
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
}));

const MiniDrawer=(props)=>{
    const [inputs] = useState(props);
    console.log("hello from the other side", inputs)


    const classes = useStyles();
    const [open, setOpen] = React.useState(true);
    const [collapsemenu, SETState] = useState(false);
    const [textItem, SetTEXT] = useState('');
    const [stateIcon, SetIcon] = useState(false)
    const [stateColor, SetColor] = useState(false)
    const [statewidth, SetWidth] = useState(false)

    

    function toggleWidth() {
        SetWidth(!statewidth)
    }

    function toggle(text) {
        SETState(!collapsemenu)
        SetTEXT(text)
        SetIcon(!stateIcon)
    }

    function changeColor(text) {
        SetTEXT(text)
        SetColor(true)
    }

    function handleDrawerClose() {
        setOpen(!open);
    }

    return (
        <div className={classes.root} id="side-nav">
            <CssBaseline />
            <AppBar
                position="fixed"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: open,
                })}
            >
                <Toolbar>
                    {/* style={{padding: "5px 20px"}} */}
                    <Link to="/Maktapti/dashboard" style={{ paddingRight: "1rem" }} >
                        <img src={ather} width="50" alt="logo" />
                    </Link>
                    <IconButton
                        aria-label="Open drawer"
                        onClick={toggleWidth}
                        edge="start"
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap>
                        <div className="loading-bar" style={{ width: "100%", position: "absolute", top: "0px" }} >
                            {/* LoadingBar */}
                            <LoadingBar style={{ zIndex: "200", backgroundColor: "orange", height: '3px', width: "150%" }} />
                        </div>
                        <Header />

                    </Typography>
                </Toolbar>
            </AppBar>
            <Drawer
                style={{ display: statewidth ? "none" : "block" }}
                variant="permanent"
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                })}
                classes={{
                    paper: clsx({
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    }),
                }}
                open={open}>

                <List>

                    {inputs.inputs.items.map((text, index) => (
                        <ListItem button key={text} style={{ marginBottom: "10px" }}>

                            <ListItemIcon style={{ display: text.children ? "none" : "inlinBlock" }}><i className={text.children ? "" : text.icon}></i></ListItemIcon>
                            {text.children ? <div className="w-100">
                                <div onClick={() => toggle(text)} >
                                    <ListItemIcon><i className={text.icon}  ></i></ListItemIcon>
                                    <span id="childSpan" onClick={() => changeColor(text)} style={{ color: localStorage.getItem("sidecolor") && text === textItem ? "#000" : "#FFF", fontWeight: "bold" }}>{text.name}</span>
                                    {stateIcon && text === textItem ? <i className="fa fa-chevron-down"></i> : <i className="fa fa-chevron-left"></i>}
                                </div>
                                <Collapse style={{ borderRight: "1px solid #333", paddingRight: "10px", marginRight: "25px" }} isOpen={collapsemenu && text === textItem}>
                                    <CardBody className="p-0">
                                        {text.children.map((child, i) => (
                                            <Link key={i} to={{
                                                pathname: child.url,
                                                state: { Client: 0 }
                                            }}><ListItemText style={{ color: "#D5D3D3", paddingBottom: "5px", fontSize: "16px" }} />{child.name} </Link>
                                        ))}
                                    </CardBody>
                                </Collapse>
                            </div> : <Link to={{
                                pathname: text.url, state: { userObject: 0, type: "all" }

                            }} onClick={() => changeColor(text)} style={{ color: stateColor && text === textItem ? "#FDBF5A" : "#FFF", fontWeight: "bold" }}><span>{text.name}</span></Link>}
                        </ListItem>
                    ))}
                </List>

                <div className={classes.toolbar} id="hidesidenav">
                    <IconButton onClick={handleDrawerClose}>
                        {!open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                </div>
            </Drawer>
        </div>
    );
}
export default MiniDrawer